import { Directive, ElementRef, HostListener, inject, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[laEllipsisTooltip]',
  standalone: true,
})
export class EllipsisTooltipDirective {
  @Input() laEllipsisTooltip!: string;

  private elementRef = inject(ElementRef);
  private matTooltip = inject(MatTooltip, { optional: true });
  private shouldShowTooltip = false;
  private lastAppliedMessage: string | null = null;
  private lastAppliedDisabled: boolean | null = null;
  private suppressUntilTs = 0;
  private debounceId: number | null = null;

  @HostListener('pointerenter')
  onPointerEnter() {
    this.scheduleRecompute();
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    this.scheduleRecompute();
  }

  @HostListener('focusin')
  onFocusIn() {
    this.scheduleRecompute();
  }

  @HostListener('document:click')
  onAnyClick() {
    this.suppressUntilTs = Date.now() + 200;
  }

  private scheduleRecompute() {
    if (Date.now() < this.suppressUntilTs) {
      return;
    }

    if (this.debounceId) {
      clearTimeout(this.debounceId);
    }

    this.debounceId = setTimeout(() => {
      this.debounceId = null;
      this.recomputeAndUpdateTooltip();
    }, 50);
  }

  private recomputeAndUpdateTooltip() {
    const element = this.elementRef.nativeElement as HTMLElement;
    this.shouldShowTooltip = element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight;

    const tooltip = this.matTooltip;
    if (!tooltip) {
      return;
    }

    const desiredDisabled = !this.shouldShowTooltip;
    const desiredMessage = this.shouldShowTooltip ? this.laEllipsisTooltip : '';

    if (this.lastAppliedDisabled !== desiredDisabled) {
      tooltip.disabled = desiredDisabled;
      this.lastAppliedDisabled = desiredDisabled;
    }

    if (!desiredDisabled && this.lastAppliedMessage !== desiredMessage) {
      tooltip.message = desiredMessage;
      this.lastAppliedMessage = desiredMessage;
    }
  }
}
